export const ASSOCIATE_TABS = ['introduction', 'elakayPromo', 'usersAdd', 'usersView', 'roleRequests', 'wallet', 'allOrderPromo', 'liveActivity'];
export const PROMOTION_VIEWS = ['configure', 'qrDesigner', 'poster', 'business'];

export const resolveAssociateNavigation = (search, canViewLive = false) => {
  const query = new URLSearchParams(search);
  const rawTab = query.get('tab') ?? query.get('page') ?? 'introduction';
  const allowed = ASSOCIATE_TABS.filter(tab => tab !== 'liveActivity' || canViewLive);
  const tab = allowed.includes(rawTab) ? rawTab : 'introduction';
  const view = tab === 'elakayPromo' && PROMOTION_VIEWS.includes(query.get('view')) ? query.get('view') : 'configure';
  return { tab, view };
};

export const associateSearch = (search, tab, view = 'configure') => {
  const query = new URLSearchParams(search);
  query.delete('page');
  query.set('tab', tab || 'introduction');
  if (tab === 'elakayPromo') query.set('view', view);
  else query.delete('view');
  return `?${query.toString()}`;
};
